import script from "./BaseDrop.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDrop.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDrop.vue?vue&type=style&index=0&id=4b83a13f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b83a13f"]])

export default __exports__